const ForumComponent = () => import('@/views/Forum/ForumView')

export default [
    {
        path:'/ForumIndex',
        name:'ForumRouter',
        component:ForumComponent
    }
]